import React from 'react';
import { Modal } from "antd";
import SmsPackagesCards from "./_SmsPackagesCards";

interface SmsPackagesModalProps {
  uid: string | null;
  number: string;
  onClose: () => void;
}

const _SmsPackagesModal = ({ uid, number, onClose }: SmsPackagesModalProps) => (
  <Modal
    title={`SMS Packages — ${number}`}
    open={!!uid}
    onCancel={onClose}
    footer={null}
    width={700}
    destroyOnClose
  >
    {uid && <SmsPackagesCards uid={uid} />}
  </Modal>
);

export default _SmsPackagesModal;
